<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Katalog Marka Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <strong>Not:</strong>
              Katalog markalarını güncelleyebilir ve çeviri ekleyebilirsiniz.
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Markalar">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <th>ID</th>
                    <th>UZAK ID</th>
                    <th>MARKA ADI</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                  <draggable
                    v-model="brands"
                    class="cursor-move"
                    tag="tbody"
                    @change="outputData"
                  >
                    <tr v-for="brand in brands" :key="brand.id">
                      <td>{{ brand.id }}</td>
                      <td>{{ brand.remoteId }}</td>
                      <td>{{ brand.title }}</td>

                      <td>
                        <b-badge v-if="brand.isDraft == false" variant="light-success">
                          Yayında
                        </b-badge>
                        <b-badge v-if="brand.isDraft == true" variant="light-warning">
                          Taslakta
                        </b-badge>
                      </td>
                      <td>{{ brand.createdAt }}</td>
                      <td>
                        <b-button-group class="float-right mr-2">
                          <b-button
                            v-for="language in languages"
                            :key="language.locale"
                            @click="action(brand, language.locale)"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            :variant="
                              brand.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'outline-warning'
                                : 'outline-secondary'
                            "
                            :title="
                              brand.languages.find(
                                (element) => element == language.locale
                              )
                                ? 'Düzenle'
                                : 'Ekle'
                            "
                          >
                            {{ language.locale.toUpperCase() }}
                          </b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </draggable>
                  <thead>
                    <th>ID</th>
                    <th>UZAK ID</th>
                    <th>KATEGORİ ADI</th>
                    <th>DURUM</th>
                    <th>TARİH</th>
                    <th>İŞLEMLER</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="currentPage"
                    :total-rows="rows"
                    :per-page="limit"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getCatalogBrands(value, limit)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BPagination,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    draggable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      request: [],
      languages: [],
      brands: [],
      rows: 100,
      limit: 10,
      currentPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getCatalogBrands(newVal, this.limit);
      },
      deep: true,
    },
  },
  methods: {
    action(node, locale) {
      let translationControl = node.languages.find((element) => element == locale);
      if (translationControl == undefined) {
        this.$router.push({
          path: `/catalog/brands/create/translation/${node.id}?targetLocale=${locale}&page=${this.currentPage}`,
        });
      } else {
        this.$router.push({
          path: `/catalog/brands/edit/${node.id}?targetLocale=${locale}&page=${this.currentPage}`,
        });
      }
    },
    outputData() {
      this.updateSubmit();
    },
    updateSubmit() {
      Object.entries(this.brands).forEach(([key, value]) => {
        let brandsOrder = {
          id: value.id,
          order: parseInt(key),
        };
        this.request.push(brandsOrder);
      });
      endpoints
        .putCatalogBrandsOrder(
          { catalogBrands: this.request },
          this.limit,
          this.currentPage,
          this.$i18n.locale,
          () => {}
        )
        .then((data) => {
          this.$swal({
            icon: "success",
            title: "Güncelleme başarılı!",
            text: "Marka sıralaması güncellendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCatalogBrands(page, limit) {
      this.currentPage = page;
      endpoints
        .getCatalogBrands(page, limit, this.$i18n.locale, () => {})
        .then((data) => {
          this.brands = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getLanguages();
    this.getCatalogBrands(this.currentPage, this.limit);
  },
};
</script>
<style>
.draggable-card {
  margin-bottom: 0;
}

.draggable-card > .card-body {
  padding: 10px;
}

.draggable-card > .card-body > .card-title {
  margin-bottom: 0;
  font-size: 1rem;
}

.tree-node {
  border: 0 !important;
}
</style>
